import UserManagementDashboard from './UserManagementDashboard';

export default UserManagementDashboard;
